var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, PropSync, Prop } from 'vue-property-decorator';
import CompanyDetailsBodySkeleton from 'components/CompanyDetailsBodySkeleton.vue';
import CompanyDrawerSummaryTab from 'components/CompanyDrawerSummaryTab.vue';
import CompanyDrawerRegisterTab from 'components/CompanyDrawerRegisterTab.vue';
import CompanyDrawerContactTab from 'components/CompanyDrawerContactTab.vue';
import CompanyDrawerDecisorsTab from 'components/CompanyDrawerDecisorsTab.vue';
import CompanyDrawerAdditionalDataTab from 'components/CompanyDrawerAdditionalDataTab.vue';
import CompanyDrawerSpecialDataTab from 'components/CompanyDrawerSpecialDataTab.vue';
import SearchNoCredits from '@/modules/search/components/SearchNoCredits.vue';
import { isEmpty } from 'lodash';
import { CompanyStatus } from '@/overmind/search/state';
import { createSearch } from '@/clients/search';
let CompanyDetailsBody = class CompanyDetailsBody extends Vue {
    constructor() {
        super(...arguments);
        this.creatingSearch = '';
    }
    notLoadedCompany() {
        return (this.companyStatus === CompanyStatus.FETCHING || isEmpty(this.company));
    }
    hasHyperbolicData() {
        return this.company.badges &&
            this.company.badges.hyperbolictree_size_estimation &&
            this.hyperbolicDataIsValid() &&
            this.hyperbolicData.nodes.length > 0 &&
            this.hyperbolicData.links.length > 0
            ? this.company.badges.hyperbolictree_size_estimation > 1
            : false;
    }
    hyperbolicDataIsValid() {
        return (this.company.matriz == '1' &&
            this.hyperbolicData &&
            this.hyperbolicData.nodes &&
            this.hyperbolicData.links);
    }
    getCompanyCnpjsNextPage(page) {
        this.$emit('getCompanyCnpjsNextPage', page);
    }
    async searchByPrimaryCnae(cnae) {
        const params = {
            search: {
                match_either: [{ cnae1: [cnae] }],
                offset: 0,
                return_size: 10,
                aggregation_type: 'advanced',
            },
        };
        await this.createNewSearchAndRedirect(params, 'cnae');
    }
    async searchBySecondaryCnae(cnae) {
        const params = {
            search: {
                match_either: [{ cnae2: [cnae] }],
                offset: 0,
                return_size: 10,
                aggregation_type: 'advanced',
            },
        };
        await this.createNewSearchAndRedirect(params, 'cnae');
    }
    async searchByCnpj(cnpj) {
        const params = {
            search: {
                match: { nu_cnpj: [cnpj.replace(/\D/g, '')] },
                offset: 0,
                return_size: 10,
                aggregation_type: 'advanced',
            },
        };
        await this.createNewSearchAndRedirect(params, 'cnpj');
    }
    async searchByCep(cep) {
        const params = {
            search: {
                match: { nu_cep: [cep.replace(/\D/g, '')] },
                offset: 0,
                return_size: 10,
                aggregation_type: 'advanced',
            },
        };
        await this.createNewSearchAndRedirect(params, 'cep');
    }
    async createNewSearchAndRedirect(params, type) {
        this.creatingSearch = type;
        try {
            const response = await createSearch(params);
            const searchId = response.data.search_id;
            window.open(`${window.location.origin}/search/${searchId}`, '_blank');
        }
        catch (e) {
            console.log(e);
        }
        this.creatingSearch = '';
    }
};
__decorate([
    PropSync('currentTab', { default: 'summary' })
], CompanyDetailsBody.prototype, "tab", void 0);
__decorate([
    Prop({ default: () => { } })
], CompanyDetailsBody.prototype, "company", void 0);
__decorate([
    Prop({ default: '' })
], CompanyDetailsBody.prototype, "additionalDataState", void 0);
__decorate([
    Prop({ default: false })
], CompanyDetailsBody.prototype, "noCreditsToGetCompany", void 0);
__decorate([
    Prop({ default: CompanyStatus.INITIAL })
], CompanyDetailsBody.prototype, "companyStatus", void 0);
__decorate([
    Prop({ default: () => { } })
], CompanyDetailsBody.prototype, "hyperbolicData", void 0);
CompanyDetailsBody = __decorate([
    Component({
        name: 'CompanyDetailsBody',
        components: {
            CompanyDetailsBodySkeleton,
            CompanyDrawerSummaryTab,
            CompanyDrawerRegisterTab,
            CompanyDrawerContactTab,
            CompanyDrawerDecisorsTab,
            CompanyDrawerAdditionalDataTab,
            CompanyDrawerSpecialDataTab,
            SearchNoCredits,
        },
    })
], CompanyDetailsBody);
export default CompanyDetailsBody;
